module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Home_16"],"polygon":[{"$":{"points":"8 0 0 7 2 7 2 15 6 15 6 10 10 10 10 15 14 15 14 7 16 7 8 0","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Home_16.svg
// module id = 1TCl
// module chunks = 1